import React, {useContext, useEffect, useState} from 'react'
import { Checkbox } from "antd";
import {OfferContext} from "../../../context/OfferContext";

const OfferGiftCheckbox = ({rowIndex, record}) => {

    const {materialInformation} = useContext(OfferContext)
    const [materials, setMaterials] = materialInformation

    const [checked, setChecked] = useState()

    useEffect(() => {
        if (record.hasOwnProperty('gift')) setChecked(record.gift)
    })

    const onChange = ({target}) => {
        target.checked ? onChecked() : onUnChecked()
    }

    const onChecked = () => {
        const mockContext = [...materials]
        mockContext[rowIndex].gift = true;
        mockContext[rowIndex].lastPrice = mockContext[rowIndex].unitPrice;
        mockContext[rowIndex].unitPrice = 0;
        setMaterials(mockContext)
    }

    const onUnChecked = () => {
        const mockContext = [...materials]
        mockContext[rowIndex].gift = false;
        mockContext[rowIndex].unitPrice = mockContext[rowIndex].lastPrice;
        setMaterials(mockContext)
    }

    return(
        <React.Fragment>
            <Checkbox style={{marginBottom: '24px'}} onChange={onChange} checked={checked} />
        </React.Fragment>
    )
}

export default OfferGiftCheckbox